import Vue from 'vue';
import Router from 'vue-router';
import i18n from './locale';

Vue.use(Router);

const router = new Router({
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            redirect: '/de/basic'
        },
        {
            path: '/:lang/basic',
            name: 'basic',
            component: () => import(/* webpackChunkName: "basic" */ './views/Basic.vue')
        },
        {
            path: '/:lang/social',
            name: 'social',
            component: () => import(/* webpackChunkName: "social" */ './views/Social.vue')
        },
        {
            path: '/:lang/options',
            name: 'options',
            component: () => import(/* webpackChunkName: "options" */ './views/Options.vue')
        },
        {
            path: '/:lang/addons',
            name: 'addons',
            component: () => import(/* webpackChunkName: "addons" */ './views/Addons.vue')
        },
        {
            path: '/:lang/projects',
            name: 'projects',
            component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue')
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});

router.beforeEach((to, from, next) => {
    const locale = to.params.lang;
    const availableLocales = ['de', 'en'];

    if (!availableLocales.includes(locale)) {
        return next('/de');
    }

    i18n.locale = locale;
    next();
});

export default router;
